import React from "react";
import { API_PATHS } from "../../types/apiPaths";
import { AdminJobPanel } from "./AdminJobPanel";
var STAT_FIELDS = [
    {
        key: "titlesProcessed",
        labelId: "ui-br-legaldeposits.admin.backfill.stats.titles",
    },
    {
        key: "depositRecordsCreated",
        labelId: "ui-br-legaldeposits.admin.backfill.stats.records",
    },
    {
        key: "titlesSkipped",
        labelId: "ui-br-legaldeposits.admin.backfill.stats.skipped",
    },
];
export var DepositRecordBackfill = function () { return (React.createElement(AdminJobPanel, { queryKey: "admin-backfill-status", statusPath: API_PATHS.LEGAL_DEPOSITS_ADMIN_BACKFILL_STATUS, triggerPath: API_PATHS.LEGAL_DEPOSITS_ADMIN_BACKFILL, i18nPrefix: "ui-br-legaldeposits.admin.backfill", statFields: STAT_FIELDS })); };
